import { Axios } from '@/config/axios'

const state = {
}

const getters = {
}

const actions = {
    getQuarantines ({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(`/api/quarantines?page=${data.page}&perPage=${data.perPage}&ohpEuid=${data.adminOhpEuid}`).then((response) => {
                resolve(response.data.data)
            })
                .catch(function (error) {
                    reject(error.response)
                })
        })
    },
    unQuarantineFile ({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.patch(`/api/action-quarantine-file`, data).then((response) => {
                resolve(response.data.data)
            })
                .catch(function (error) {
                    reject(error.response)
                })
        })
    }
}

const mutations = {
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
